import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UnityCard.css';

const UnityCard = ({ course }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/class/${course.id}`);
  };

  return (
    <div className="unity-card" onClick={handleClick}>
      <div className="unity-image">
        <img src={course.image} alt={course.title} className="card-image" />
      </div>
      <div className="unity-info">
        <h3 className="unity-title">{course.title}</h3>
        <p className="unity-description">{course.description}</p>
        <div className="unity-stats">
          <div className="stats-item">
            <span>加课学员: </span>
            <span>{course.students}</span>
          </div>
          <div className="stats-item">
            <span>综合评分: </span>
            <span>★ {course.rating}</span>
          </div>
        </div>
        <div className="unity-bottom">
          <div className="unity-price">
            <span className="unity-current-price">¥{course.price}</span>
            {course.originalPrice && (
              <span className="unity-original-price">¥{course.originalPrice}</span>
            )}
          </div>
          <div className="unity-buttons">
            <span className="enroll-count">{course.enrollCount}人入学</span>
            <button className="enroll-btn">加入班级</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnityCard; 